import { SvgIcon } from "@mui/material";
import type { SvgIconProps } from "@mui/material";
import tourTokens from "../styles/tour.tokens";

const t = tourTokens;

export const TourCloseIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    sx={{ fill: "none", ...props.sx }}
    aria-hidden="true"
  >
    <path
      d="M18 6L6 18M6 6l12 12"
      stroke="currentColor"
      strokeWidth={t.close.iconStroke}
      strokeLinecap="round"
      fill="none"
    />
  </SvgIcon>
);

export const TourChevronRightIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    sx={{ fill: "none", ...props.sx }}
    aria-hidden="true"
  >
    <path
      d="M9 6l6 6-6 6"
      stroke="currentColor"
      strokeWidth={t.actions.chevronStroke}
      strokeLinecap="round"
      fill="none"
    />
  </SvgIcon>
);

export const TourWelcomeIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    sx={{ fill: "none", ...props.sx }}
    aria-hidden="true"
  >
    <path
      d="M12 20h9"
      stroke="currentColor"
      strokeWidth={t.modal.welcomeGlyphStroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"
      stroke="currentColor"
      strokeWidth={t.modal.welcomeGlyphStroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);

export const TourCompleteIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    sx={{ fill: "none", ...props.sx }}
    aria-hidden="true"
  >
    <path
      d="M20 6 9 17l-5-5"
      stroke="currentColor"
      strokeWidth={t.modal.completeGlyphStroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);

export const TourTileIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    sx={{ fill: "none", ...props.sx }}
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="1.8"
      fill="none"
    />
    <path
      d="M15.6 8.4l-2.05 5.15-5.15 2.05 2.05-5.15 5.15-2.05z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);

export default TourTileIcon;
